module.exports = __webpack_public_path__ + "static/media/alpha_25.ace6b341.png";